import styled from 'styled-components';

export const MainModalStyles = {
  TitleTextWrapper: styled.div`
    width: 250px;
  `,
};
